export enum OnboardingStep {
  user_profile = 'user_profile',
  shopify_setup = 'shopify_setup',
  theme_selection = 'theme_selection',
  custom_app_integration = 'custom_app_integration',
  collab_code = 'collab_code',
  pg_setup = 'pg_setup',
  org_details = 'org_details',
  tnc_agreement = 'tnc_agreement',
  integration_setup = 'integration_setup',
  go_live = 'go_live',
  test_shopflo = 'test_shopflo'
}

export type OnboardingStepType = {
  id: OnboardingStep
  mandatory: boolean
}

export type SubscriptionV2Type = {
  id: string
  realEstate: string
}

export type Gateway = {
  pg: string
  is_configured: boolean
  configuration_url: string | null
}

export interface StepComponentProps {
  stepId: OnboardingStep
  submitStep: () => Promise<void>
  currentStep: OnboardingStep
  setCurrentStep: (step: OnboardingStep) => void
  completedSteps: OnboardingStep[]
  unlockedSteps: OnboardingStep[]
  pgSetup: {
    response: Gateway[]
    isLoading: boolean
  }
  businessDetails: {
    businessCategories: BusinessCategory[]
    isLoading: boolean
  }
  addSubscription: {
    tncLink: string
  }
  previewUrl: string
}

export type BusinessCategory = {
  id: string
  display_name: string
}

export type OnboardingStateType = {
  id: string
  parent_id: string
  mandatory: boolean
}

export interface TimerApiResponse {
  success: boolean
  data: {
    merchant_id: string
    time_left: number
    status: 'ACTIVE' | 'EXPIRED'
    created_at: string
    updated_at: string
  }
}

export type OnboardingType = 'CHECKOUT' | 'SSO'
